import { render, staticRenderFns } from "./staticliuliangProdct1.vue?vue&type=template&id=03cc2681&scoped=true&"
import script from "./staticliuliangProdct1.vue?vue&type=script&lang=js&"
export * from "./staticliuliangProdct1.vue?vue&type=script&lang=js&"
import style0 from "./staticliuliangProdct1.vue?vue&type=style&index=0&id=03cc2681&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cc2681",
  null
  
)

export default component.exports